<template>
  <div>
    <v-container>
      <v-row>
        <v-col>
          <h1>Tags</h1>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  head() {
    return {
      title: "Tags",
      meta: [{ name: "description", content: "ICJIA content tags." }],
    };
  },
};
</script>

<style lang="scss" scoped></style>
